const SESSION_KEY = "starlive_game_recharge_session"
const ORDER_KEY = "starlive_game_recharge_order"

export function saveGameRechargeSession(payload) {
  const expiresAt = Date.now() + Math.max(0, Number(payload.expires_in || 0) * 1000)
  sessionStorage.setItem(SESSION_KEY, JSON.stringify({ token: payload.access_token || "", expiresAt }))
}

export function getGameRechargeToken() {
  try {
    const session = JSON.parse(sessionStorage.getItem(SESSION_KEY) || "{}")
    if (!session.token || Number(session.expiresAt || 0) <= Date.now()) {
      sessionStorage.removeItem(SESSION_KEY)
      return ""
    }
    return String(session.token)
  } catch (_) {
    sessionStorage.removeItem(SESSION_KEY)
    return ""
  }
}

export function clearGameRechargeSession() {
  sessionStorage.removeItem(SESSION_KEY)
  sessionStorage.removeItem(ORDER_KEY)
}

export function saveGameRechargeOrder(orderNo) {
  sessionStorage.setItem(ORDER_KEY, String(orderNo || ""))
}

export function getGameRechargeOrder() {
  return sessionStorage.getItem(ORDER_KEY) || ""
}

export function consumeCheckoutTicket() {
  const url = new URL(window.location.href)
  const ticket = url.searchParams.get("ticket") || ""
  if (ticket) {
    url.searchParams.delete("ticket")
    history.replaceState(history.state, document.title, `${url.pathname}${url.search}${url.hash}`)
  }
  return ticket
}
